import Mention from '@tiptap/extension-mention'

export default Mention.extend({
  name: 'mention',

  addAttributes() {
    return {
      id: {
        default: null,
      },
      label: {
        default: null,
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-type="mention"]',
        getAttrs: (dom) => {
          const el = dom as HTMLElement
          return {
            id: el.getAttribute('data-id'),
            label: el.innerText.replace(/^@/, ''),
          }
        },
      },
    ]
  },

  renderHTML({ node }) {
    return [
      'span',
      {
        class: 'mention',
        'data-type': 'mention',
        'data-id': node.attrs.id,
        contenteditable: 'false',
      },
      `@${node.attrs.label}`,
    ]
  },
})
